import {action} from "mobx";
import walletService from "../services/walletService";
import appStore from "./appStore";

class walletStore {
    @action createAndActivateCourierWallet = async params => {
        const resultOfRequest = await walletService.createAndActivateCourierWallet(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateCourierWalletBlockedBalance = async params => {
        const resultOfRequest = await walletService.updateCourierWalletBlockedBalance(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateCourierWalletCashOnDeliveryLimitOffset = async params => {
        const resultOfRequest = await walletService.updateCourierWalletCashOnDeliveryLimitOffset(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getDailyTransactionsSummary = async params => {
        const resultOfRequest = await walletService.getDailyTransactionsSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierWalletWithDailyTransactionsSummary = async params => {
        const resultOfRequest = await walletService.getCourierWalletWithDailyTransactionsSummary(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }

        // Backend'den success: false gelirse kontrol et
        if (resultOfRequest.data && resultOfRequest.data.success === false) {
            // Sadece WALLET_NOT_FOUND durumunda null döndür
            if (resultOfRequest.data.errorCode === "WALLET_NOT_FOUND") {
                return {data: null};
            }
            // Diğer hatalarda normal hata modal'ı göster
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }

        return resultOfRequest.data;
    };

    @action getDailyTransactions = async params => {
        const resultOfRequest = await walletService.getDailyTransactions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierCreditLogSummary = async params => {
        const resultOfRequest = await walletService.getCourierCreditLogSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierPaymentInvoices = async params => {
        const resultOfRequest = await walletService.getCourierPaymentInvoices(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourierWalletPayments = async params => {
        const resultOfRequest = await walletService.getCourierWalletPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listWalletCouriers = async params => {
        const resultOfRequest = await walletService.listWalletCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action exportCourierWalletTransactions = async params => {
        const resultOfRequest = await walletService.exportCourierWalletTransactions(params);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action blockWithdrawAction = async params => {
        const resultOfRequest = await walletService.blockWithdrawAction(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action unblockWithdrawAction = async params => {
        const resultOfRequest = await walletService.unblockWithdrawAction(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getWalletInvoiceVendors = async params => {
        const resultOfRequest = await walletService.getWalletInvoiceVendors(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action listWalletCourierFinancials = async params => {
        const resultOfRequest = await walletService.listWalletCourierFinancials(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action uploadWalletCourierFinancialFile = async params => {
        const resultOfRequest = await walletService.uploadWalletCourierFinancialFile(params);
        const raw = resultOfRequest?.data || {};

        let normalized;
        if (raw.excelResult) {
            normalized = {
                ...raw.excelResult,
                errorReport: raw.excelResult.errorExcel
            };
        } else if (raw.result !== undefined) {
            normalized = {...raw.result};
        } else {
            normalized = {...raw};
        }

        if (resultOfRequest.status !== 200 && !normalized?.errorExcel && !normalized?.errorReport) {
            appStore.openErrorModal({
                content: normalized?.message || raw?.message || "Yükleme başarısız oldu."
            });
        }
        return {data: normalized};
    };

    @action async listUploadTypes() {
        const resultOfRequest = await walletService.listUploadTypes();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data?.message});
            return {success: false, data: []};
        }
        const raw = resultOfRequest.data;
        if (Array.isArray(raw)) {
            return {success: true, data: raw};
        }
        if (raw?.data != null && Array.isArray(raw.data)) {
            return {success: raw.success !== false, data: raw.data};
        }
        return {success: true, data: []};
    }

    @action async getCourierFinancialUploadsTemplate() {
        const resultOfRequest = await walletService.getCourierFinancialUploadsTemplate();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data?.message});
            return {success: false, message: resultOfRequest.data?.message};
        }
        const raw = resultOfRequest.data || {};
        const base64Payload =
            raw.data?.result ?? raw.result ?? (typeof raw.data === "string" ? raw.data : null);
        return {
            success: raw.success !== false,
            message: raw.message,
            data: base64Payload
        };
    }

    @action async createFinancialUploadExcelToSpecificCourier(params) {
        const resultOfRequest = await walletService.createFinancialUploadExcelToSpecificCourier(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async generateWithdrawSummary(params) {
        const resultOfRequest = await walletService.generateWithdrawSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async approveWithdraw(params) {
        const resultOfRequest = await walletService.approveWithdraw(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return resultOfRequest.data;
    }

    @action async bulkWithdrawTerminated(params) {
        const resultOfRequest = await walletService.bulkWithdrawTerminated(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        const {created, errors} = resultOfRequest.data?.data || {};
        const summaryLines = [
            `Oluşturulan talep sayısı: ${created ?? 0}`,
            ...(errors || []).map(error => `${error.title}: ${error.count}`)
        ];
        appStore.openSuccessModal({
            title: "Toplu Para Çekim Talebi",
            content: [
                "Toplu para çekim talebi oluşturma işlemi tamamlandı. İşlem sonucunda oluşan kayıtların özeti aşağıda yer almaktadır:",
                "",
                ...summaryLines
            ].join("\n")
        });
        return resultOfRequest.data;
    }

    @action async getTerminatedCouriersCountForWithdraw() {
        const resultOfRequest = await walletService.getTerminatedCouriersCountForWithdraw();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return null;
        }
        return resultOfRequest.data;
    }

    @action deactivateCourierWallet = async (courierId, {reason}) => {
        const resultOfRequest = await walletService.deactivateCourierWallet(courierId, {reason});
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Cüzdan deaktive edildi."
        });
        return true;
    };

    @action activateCourierWallet = async (
        courierId,
        {reason, processCreditLogs = true, creditLogStartDate}
    ) => {
        const resultOfRequest = await walletService.activateCourierWallet(courierId, {
            reason,
            processCreditLogs,
            creditLogStartDate
        });
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Cüzdan aktive edildi."
        });
        return true;
    };

    @action getWalletActivationPreview = async (
        courierId,
        {customStartDate, customStartTime} = {}
    ) => {
        const resultOfRequest = await walletService.getWalletActivationPreview(courierId, {
            customStartDate,
            customStartTime
        });
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action sendWithdrawSms = async params => {
        const resultOfRequest = await walletService.sendWithdrawSms(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action sendReturnSms = async params => {
        const resultOfRequest = await walletService.sendReturnSms(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
}

export default new walletStore();
